module.exports = __webpack_public_path__ + "img/osobne_vlastnictvo.84e089e9.svg";